<template>
  <div>
    <!-- For uploading video -->
    <template
      v-if="
        (data.questionVideoPlayed < 2 && data.questionVideoLimit) ||
        !data.questionVideoLimit
      "
    >
      <div v-for="(file, f) in data.questionFile" :key="f">
        <div class="columns">
          <div class="column is-12">
            <!-- For Displaying Video -->
            <video
              width="320"
              height="240"
              controls
              @ended="endedVideo()"
              disablePictureInPicture
              controlsList="nodownload"
              playsinline
            >
              <source v-lazy="getUrlFile(file.url)" />
            </video>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      default: () => {},
    },
    type: {
      default: () => {},
    },
  },
  methods: {
    getUrlFile(file) {
      return process.env.VUE_APP_BACKEND_URL + file;
    },
    endedVideo() {
      this.data.questionVideoPlayed += 1;
    },
  },
};
</script>

<style lang="scss">
video::-webkit-media-controls-timeline {
  display: none;
}
</style>
